'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../tslib.es6-fe93d37b.js');
require('react');
require('styled-components');
require('../_commonjsHelpers-1b94f6bc.js');
require('../device.context-f96381a3.js');
var device_context_hooks = require('../device.context.hooks-0223e9f1.js');
var device_consts = require('../device.consts-2b011893.js');
require('../mobile-detect-2421ba00.js');
var device_provider = require('../device.provider-7154f4b3.js');
var device_styles = require('../device.styles-facac80d.js');



exports.useDeviceContext = device_context_hooks.useDeviceContext;
exports.useIsMobileDevice = device_context_hooks.useIsMobileDevice;
exports.useIsMobileView = device_context_hooks.useIsMobileView;
exports.useIsSmallViewportWidth = device_context_hooks.useIsSmallViewportWidth;
exports.SMALL_DEVICE_MAX_WIDTH = device_consts.SMALL_DEVICE_MAX_WIDTH;
exports.DeviceProvider = device_provider.DeviceProvider;
exports.mediaMaxWidth = device_styles.mediaMaxWidth;
